import React, { useEffect, useState } from "react";
import Sidebar from "src/components/common/Sidebar";
import RodeoEventPage from "src/components/events/rodeoEvent/rodeoEventPage";
import { useAppGameDetailsSelector } from "src/_common/hooks/selectors/eventSelector";
import { RODEO_PAGE_NAME } from "src/_config";
import { APPLICATION_NAME } from "src/_config";
import LandingPage from "src/components/landing/landingPage";

export default function RodeoEventContainer() {
  const gameDetails = useAppGameDetailsSelector() as {
    is_show_landing_page?: number;
    redirect_automatically?: number;
    redirect_after?: number;
  } | null;
  const [isShowLandingPage, setIsShowLandingPage] = useState<boolean>(false);
  const redirected = localStorage.getItem("redirectedFromLanding");

  useEffect(() => {
    if (gameDetails?.is_show_landing_page == 1) {
      if (gameDetails?.redirect_automatically == 1) {
        setIsShowLandingPage(true);
        const timer = setTimeout(() => {
          setIsShowLandingPage(false);
          localStorage.setItem("redirectedFromLanding", "1");
        }, (gameDetails?.redirect_after ?? 0) * 1000);
        return () => clearTimeout(timer);
      } else {
        setIsShowLandingPage(true);
      }
    } else {
      setIsShowLandingPage(false);
    }
  }, [gameDetails]);

  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : Events`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  return (
    <React.Fragment>
      {/* {
                // !userDetails ?
                    <div className="logo-wrap">
                        <img src="/images/logo.png" alt="Logo" className="medium-logo" /> */}
      {/* {gameDetails?.logo?.original && <img src={gameDetails?.logo?.original} alt="Logo" className="medium-logo" />} */}
      {/* </div>
                // : null
            } */}
      <Sidebar page={RODEO_PAGE_NAME.EVENT_LIST} />
      {/* <section className="main-container"> */}
      {isShowLandingPage && redirected != "1" ? <LandingPage /> : <RodeoEventPage />}
      {/* </section> */}
    </React.Fragment>
  );
}
